<template>
  <div class="error_box">
    <div class="error_top flex-eju-space-between">
      <div>
        <div class="deep_word">当前企业未正确设置“可见范围”</div>
        <div class="normal_word">请按如下方法操作后再进行登录</div>
      </div>
      <img src="@/assets/error/error.svg" alt="" />
    </div>
    <div class="error_item">
      <div class="error_title">第一步</div>
      <div class="error_tip">
        登录企业微信管理后台
        <el-link
          href="https://work.weixin.qq.com/"
          target="_blank"
          type="primary"
          style="font-size: 16px;position: relative;top: -1px;"
          >企业微信管理后台</el-link
        >
        ，点击“应用管理”菜单，在“第三方”应用中找到“易企盈助手”点击进行设置。
      </div>
      <img src="@/assets/error/1.png" alt="" />
    </div>
    <div class="error_item">
      <div class="error_title">第二步</div>
      <div class="error_tip">点击下图中箭头所指的“修改”，然后点击“添加”，设置可见范围。</div>
      <img src="@/assets/error/2.png" alt="" />
    </div>
    <div class="error_item">
      <div class="error_title">第三步</div>
      <div class="error_tip">确保选中最顶部的组织节点，点击确认。</div>
      <img src="@/assets/error/3.png" alt="" />
    </div>
    <div class="error_item">
      <div class="error_title">第四步</div>
      <div class="error_tip">
        点击完成。完成设置后打开 
        <el-link
          href="//yqy.haoju.com"
          target="_blank"
          type="primary"
          style="font-size: 16px;position: relative;top: -1px;"
          >yqy.haoju.com</el-link
        >
        ，点击屏幕中间的“立即体验”按钮，新扫码登录。
      </div>
      <img src="@/assets/error/4.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    goIndex() {
      this.$router.replace({
        path: "/",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.error_box {
  padding: 80px 0;
  width: 860px;
  margin: 0 auto;
  box-sizing: border-box;
  .error_top {
    .deep_word {
      font-weight: bold;
      font-size: 24px;
      line-height: 36px;
      color: #1c1c1c;
      margin-bottom: 8px;
    }
    .normal_word {
      font-size: 20px;
      line-height: 30px;
      color: #3a3b3e;
    }
  }
  .error_item {
    margin-top: 48px;
  }
  .error_title {
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    color: #000000;
    margin-bottom: 24px;
  }
  .error_tip {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 24px;
  }
}
</style>